import { DarwinButton } from 'components/darwin-ui';
import { PlusCircleOutlined } from '@ant-design/icons';
import { Divider } from 'antd';
import { useTranslation } from 'react-i18next';
import emptyAddressStyles from './EmptyAddress.module.css';

type AddressBookEmptyProps = {
  handleUpdateDisplayForm: (updateDisplayForm: boolean) => void;
  handleCreateOrganization: (callback: () => void) => void;
};

export const AddressBookEmpty = ({
  handleUpdateDisplayForm,
  handleCreateOrganization,
}: AddressBookEmptyProps) => {
  const { t } = useTranslation();
  return (
    <>
      <div
        className={emptyAddressStyles.addressSectionAddAddressButtonContainer}
      >
        <DarwinButton
          className={emptyAddressStyles.addressSectionAddAddressButton}
          onClick={() => {
            handleCreateOrganization(() => handleUpdateDisplayForm(true));
          }}
        >
          {t('create-organization-form.add-address-button')}
        </DarwinButton>
      </div>
      <Divider />
      <div className={emptyAddressStyles.addressSectionContainer}>
        <div>
          <h3 className={emptyAddressStyles.addressSectionTitle}>
            {t('create-organization-form.empty-state-title')}
          </h3>
          <p className={emptyAddressStyles.addressSectionDescription}>
            {t('create-organization-form.empty-state-subtitle')}
          </p>
        </div>
        <div className={emptyAddressStyles.addressSectionIconContainer}>
          <div
            onClick={() => {
              handleCreateOrganization(() => handleUpdateDisplayForm(true));
            }}
            className={emptyAddressStyles.addressSectionIcon}
          >
            <PlusCircleOutlined />
          </div>
        </div>
      </div>
    </>
  );
};
